import type { ComboboxInputPropsInterface, ComboboxOptionType } from '@zillow/constellation-10';
import { Combobox, DropdownSelect } from '@zillow/constellation-10';

import { getTimeZoneDropdownOptions } from '../../utils/getTimeZoneDropdownOptions';
import { DisplayTimeZones, type TimeZoneIds } from '../../constants';

type TimeZoneDropdownSelectProps = {
  disableTimeZoneSelection: boolean;
  timeZone?: TimeZoneIds;
  handleOptionSelect: (option: ComboboxOptionType) => void;
};

const TimeZoneDropdownSelect = ({
  disableTimeZoneSelection,
  timeZone,
  handleOptionSelect,
}: TimeZoneDropdownSelectProps) => {
  return (
    <DropdownSelect
      placeholder="Select time zone"
      value={timeZone}
      onOptionSelect={handleOptionSelect}
      options={getTimeZoneDropdownOptions()}
      disabled={disableTimeZoneSelection}
      showLabelForValue
      renderInput={(renderProps: ComboboxInputPropsInterface) => {
        const { ref: _ref, ...adornmentPropsWithoutRef } = renderProps;
        return (
          <Combobox.Input
            {...adornmentPropsWithoutRef}
            value={timeZone ? DisplayTimeZones[timeZone] : ''}
            data-testid="TimeZoneDropdownInput"
          />
        );
      }}
      data-testid="TimeZoneDropdownSelect"
    />
  );
};

export default TimeZoneDropdownSelect;
